<template>
  <div>
    <div class="d-flex">
      <draggable :list="choices" tag="ul" class="list-group flex-fill" handle=".handle" @end="onDragEnd">
        <li v-for="(choice, idx) in choices" :key="choice.value">

          <div class="d-flex flex-row">
            <div class="p-2">
              <input v-if="innerModel.type == 'checkbox'" v-model="choice.is_answer" type="checkbox"/>
              <input v-if="innerModel.type == 'radio'" v-model="radioSelected" :value="idx" :name="componentId" type="radio"/>
            </div>
          
            <div class="flex-sm-fill p-2">
              <b-form-textarea v-model="choice.label" rows="2" max-rows="6" style="margin-bottom: 1rem;">
              </b-form-textarea>
              <media-preview v-if="choice.media" v-model="choice.media"/>
            </div>
          
            <div class="d-flex p-2">
              <media-picker 
                :tenant-id="organization.id" 
                :module-id="module.id" 
                :current="choice.media" 
                style="padding-right:.25rem;" l
                ink-text="media library" 
                @selected="onChoiceMediaSelected(choice, $event)" 
                @remove="onChoiceMediaRemoved(choice ,$event)"/>
              <div>
                <b-button title="remove" variant="outline-secondary" @click="removeAt(idx)"><i class="fa fa-sm fa-times" ></i></b-button>
                <b-button title="drag to sort" variant="outline-secondary"><i class="fa fa-sm fa-align-justify handle" title="drag to sort"></i></b-button>
              </div>
            </div>
          </div>

        </li>
      </draggable>
    </div>

    <div class="p-2">
      <b-link @click="addChoice">+ add choice</b-link>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import kcBase from '../kc-base'
import draggable from 'vuedraggable'
import mediaPicker from '../media/mediaPicker.vue'
import mediaPreview from '@/components/common/media/media-preview'

export default {
  components:{
    draggable,
    mediaPreview,
    mediaPicker
  },
  mixins: [kcBase],
  props:{
    value: {type:null, default: ''}
  }, 
  data(){
    return{
      innerModel:{}
    }
  },
  computed: {
    componentId(){
      return this._uid
    },
    choices(){
      return this.innerModel.choices
    },
    inputType(){
      return this.innerModel.type
    },
    radioSelected:{
      get(){ return _.findIndex(this.innerModel.choices, 'is_answer') },
      set(value){ 
        if(this.inputType != 'radio') {
          return
        }        
        _.each(this.innerModel.choices, (c) => {c.is_answer = false})
        this.innerModel.choices[value].is_answer = true }
    } 
  },
  watch: {   
    value(val){
      if(val != this.innerModel){
        this.innerModel = val
      }
    },
    inputType(val, oldVal){
      if(oldVal){
        _.each(this.innerModel.choices, (c) => {c.is_answer = false})
      }
    }
  }, 
  methods:{
    onDragEnd(evt){
      _.each(this.innerModel.choices, (c, i) => (c.order = i))
    },
    addChoice(){
      const order = this.innerModel.choices.length + 1
      const value = `new choice ${  order}`

      this.innerModel.choices.push({
        label: value,
        order: order,
        value: value
      })
    },
    removeAt(idx) {
      this.innerModel.choices.splice(idx, 1)
    },
    onChoiceMediaSelected(choice,media){
      choice.media = media
      choice.media_id = media.id
    }, 
    onChoiceMediaRemoved(choice){
      choice.media_id = null
      choice.media = null
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/questions/choices.vue